import { TabPill } from 'types/tabs';

/* eslint-disable import/prefer-default-export */
export { UploadStatus } from './leadFileUpload';

export const UNASSIGNED_ASSIGNEE = {
  id: 'unassigned',
  name: 'Unassigned',
  isUnassigned: true
};

export const INPUT_BASE_CLASSNAME =
  '!bg-theme border-grey40 border disabled:border-grey30 disabled:bg-grey10';

export const INPUT_FOCUS_CLASSNAME =
  'focus:outline-none focus:border-primary focus-within:border-primary focus:shadow-inputShadow';

export const INPUT_MAX_LENGTH = 50;
export const INPUT_MIN_LENGTH = 3;

export const MAX_LEAD_STATUS_COUNT = 15;

export const GROUP_MEMBER_MIN_AMOUNT = 2;
export const GROUP_MEMBER_MAX_AMOUNT = 20000;
export const SPLIT_REQUIRED_MIN_AMOUNT = 100;

export const DEFAULT_COUNSELLOR_CUSTOM_FIELD = {
  key: 'counsellor_name',
  value: null
};

export const feeCollectionTabOptions: TabPill[] = [
  { id: 1, label: 'Payment' },
  { id: 2, label: 'Branch/group' }
];
